<script lang="ts">
  import SpreadSheetTable from '$shared/atoms/SpreadSheetTable/SpreadSheetTable.svelte';
  import type { CsvPreview } from '$provider/models/filePreview/CsvPreview';

  interface Props {
    data: CsvPreview;
  }

  let { data }: Props = $props();
</script>

<div class="csv-previewer">
  <SpreadSheetTable headers={data?.headers} rows={data?.rows} />
</div>

<style>
  .csv-previewer {
    overflow: auto;
    max-width: 100%;
    max-height: 100%;
    border: 1px solid #ccc;
  }
</style>
